import { Button, Drawer, Skeleton } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { useState } from 'react'
import LoadingIndicator from 'src/common/components/LoadingIndicator'
import ArchiveIcon from 'src/common/icons/archiveIcon'
import EditIcon from 'src/common/icons/editIcon'

import ArchiveDialog from 'src/common/components/ArchiveDialog'
import UserAvatar from 'src/common/components/UserAvatar'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { SortHeader, timelineOptions } from '../CampaignCreate'
import { CloseDrawer } from 'src/common/icons/closeDrawer'
import simulationCampaignsService from 'src/services/simulation-campaigns.service'
import CustomTemplatePreview from '../templatePreview'
import { UserViewContext } from 'src/App'
import CampaignUsersStatus from 'src/common/components/CampaignUsersStatus'
import { Letter } from 'react-letter'
import TemplateView from 'src/views/TemplateView'
import Spacer from 'src/common/components/Spacer'
import UnArchiveIcon from 'src/common/icons/unArchiveIcon'
import DownloadIcon from 'src/common/icons/downloadIcon'

const CampaignViewDetails = ({ simulationsStats, users, simulations }) => {
  dayjs.extend(utc)
  const [sortBy, setSortBy] = useState(null)
  // const [loading, setLoading] = useState(true)

  // const [users, setUsers] = useState([])
  const [sortedItems, setSortedItems] = useState(null)
  const [sortedSimItems, setSortedSimItems] = useState(null)

  const [activeTab, setActiveTab] = useState(1)
  const [, setUserViewId] = useContext(UserViewContext)

  const tabs = [
    { id: 1, text: 'Users' },
    { id: 2, text: 'Simulations' }
  ]

  useEffect(() => {
    if (users && users.length) {
      setSortedItems(users)
    } else {
      setSortedItems([])
    }
    if (simulations && simulations.length) {
      setSortedSimItems(
        simulations.map(el => ({
          ...el,
          email: users.find(user => user.userId == el.userId).email
        }))
      )
    } else {
      setSortedSimItems([])
    }
  }, [users, simulations])

  const handleExportSimulations = () => {
    const csvRows = []
    const headers = ['firstName', 'lastName', 'email', 'subject', 'status', 'actionAt']

    csvRows.push(headers.join(';'))

    for (const row of sortedSimItems) {
      const values = headers.map(header => `${row[header]}`)
      csvRows.push(values.join(';'))
    }

    const csvContent = csvRows.join('\n')
    const bom = '\uFEFF'
    const csvContentWithBom = bom + csvContent

    const blob = new Blob([csvContentWithBom], {
      type: 'text/csv;charset=utf-8;'
    })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.href = url
    link.setAttribute('download', `export-campaign.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleSort = field => {
    const fieldset = {
      'name & email': 'name',
      status: 'status'
    }
    const fieldName = fieldset[field.toLowerCase()]
    const asc = field == sortBy?.name ? !sortBy.asc : true

    setSortedItems(
      users
        .map(el => ({
          ...el,
          name: el.firstName + (el?.lastName || '') || ''
        }))
        .sort((a, b) => {
          if (a[fieldName] < b[fieldName]) {
            return asc ? -1 : 1
          }
          if (a[fieldName] > b[fieldName]) {
            return asc ? 1 : -1
          }
          return 0
        })
    )

    setSortBy({ name: field, asc: asc })
  }

  const handleSortSims = field => {
    const fieldset = {
      'user name': 'name',
      subject: 'subject',
      status: 'status',
      'date & time': 'actionAt'
    }
    const fieldName = fieldset[field.toLowerCase()]
    const asc = field == sortBy?.name ? !sortBy.asc : true
    setSortedSimItems(
      simulations
        .map(el => ({
          ...el,
          email: users.find(user => user.userId == el.userId).email
        }))
        .map(el => ({
          ...el,
          name: el.firstName + (el?.lastName || '') || ''
        }))
        .sort((a, b) => {
          if (fieldName == 'actionAt') {
            if (dayjs(a[fieldName]).unix() < dayjs(b[fieldName]).unix()) {
              return asc ? -1 : 1
            }
            if (dayjs(a[fieldName]).unix() > dayjs(b[fieldName]).unix()) {
              return asc ? 1 : -1
            }
            return 0
          } else {
            if (a[fieldName].toLowerCase().replaceAll(' ', '') < b[fieldName].toLowerCase().replaceAll(' ', '')) {
              return asc ? -1 : 1
            }
            if (a[fieldName].toLowerCase().replaceAll(' ', '') > b[fieldName].toLowerCase().replaceAll(' ', '')) {
              return asc ? 1 : -1
            }
            return 0
          }
        })
    )

    setSortBy({
      name: field,
      asc: field == sortBy?.name ? !sortBy.asc : true
    })
  }

  const handleTabChange = name => {
    setActiveTab(tabs.find(el => el.text == name).id)
  }

  return (
    <>
      <h2
        style={{
          fontSize: '24px',
          fontFamily: 'Satoshi',
          marginBottom: '20px'
        }}
      >
        Overall status for campaign
      </h2>

      <div
        style={{
          background: '#fff',
          borderRadius: '10px',
          padding: '18px 32px',
          marginBottom: '32px'
        }}
        className='row row-center'
      >
        <div className='column' style={{ marginRight: '36px' }}>
          <p
            style={{
              color: '#76767F',
              fontSize: '14px',
              marginBottom: '8px'
            }}
          >
            Reported
          </p>
          <div style={{ alignItems: 'flex-end' }} className='row'>
            <p
              style={{
                color: '#00BC62',
                fontSize: '24px',
                lineHeight: '24px',
                fontFamily: 'Satoshi',
                marginRight: '6px'
              }}
            >
              {simulationsStats &&
                (simulationsStats?.reportedCount === 0
                  ? 0
                  : Math.round((simulationsStats?.reportedCount / simulationsStats?.totalCount) * 100))}
              %
            </p>
            <p style={{ color: '#76767F', fontSize: '16px' }}>{simulationsStats?.reportedCount}</p>
          </div>
        </div>

        <div className='column' style={{ marginRight: '36px' }}>
          <p
            style={{
              color: '#76767F',
              fontSize: '14px',
              marginBottom: '8px'
            }}
          >
            Phished
          </p>
          <div style={{ alignItems: 'flex-end' }} className='row'>
            <p
              style={{
                fontSize: '24px',
                lineHeight: '24px',
                fontFamily: 'Satoshi',
                marginRight: '6px'
              }}
            >
              {simulationsStats?.phishedPercentage || 0}%
            </p>
            <p style={{ color: '#76767F', fontSize: '16px' }}>{simulationsStats?.phishedCount || 0}</p>
          </div>
        </div>

        <div className='column' style={{ marginRight: '36px' }}>
          <p
            style={{
              color: '#76767F',
              fontSize: '14px',
              marginBottom: '8px'
            }}
          >
            Opened
          </p>
          <div style={{ alignItems: 'flex-end' }} className='row'>
            <p
              style={{
                fontSize: '24px',
                lineHeight: '24px',
                fontFamily: 'Satoshi',
                marginRight: '6px'
              }}
            >
              {simulationsStats?.openedPercentage || 0}%
            </p>
            <p style={{ color: '#76767F', fontSize: '16px' }}>{simulationsStats?.openedCount || 0}</p>
          </div>
        </div>

        <div style={{ flex: '1', position: 'relative' }}>
          <div
            style={{
              background: '#E7E7EE',
              height: '16px',
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden'
            }}
            className='row row-center'
          >
            {simulationsStats?.reportedPercentage !== 0 && (
              <div
                style={{
                  width: (simulationsStats?.reportedPercentage || 0) + '%',
                  background: '#59D399',
                  minWidth: '21px',
                  height: '21px',
                  borderRadius: '16px',
                  position: 'relative',
                  border: '3px solid #fff',
                  marginRight: '-10px'
                }}
              ></div>
            )}
            {simulationsStats?.phishedPercentage !== 0 && (
              <div
                style={{
                  width: (simulationsStats?.phishedPercentage || 0) + '%',
                  background: '#EF5E3A',
                  minWidth: '21px',
                  height: '21px',
                  borderRadius: '16px',
                  position: 'relative',
                  border: '3px solid #fff',
                  marginLeft: '0px'
                }}
              ></div>
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          marginBottom: '36px',
          alignItems: 'center'
        }}
        className='row tabs'
      >
        {tabs.map(el => (
          <div
            key={el.id}
            onClick={() => handleTabChange(el.text)}
            className={`tab ${activeTab == el.id && 'tab-active'}`}
          >
            <p>{el.text}</p>
          </div>
        ))}
        <Spacer />
        {activeTab == 2 && (
          <Button
            onClick={handleExportSimulations}
            className='export-btn'
            sx={{
              fontFamily: 'Plus Jakarta Sans',
              textTransform: 'none',
              borderRadius: '8px',
              color: '#6123FF',
              borderColor: '#E7E7EE'
            }}
            variant={'outlined'}
            startIcon={<DownloadIcon color={'#6123FF'} />}
          >
            Export Results
          </Button>
        )}
      </div>

      {activeTab == 1 && (
        <>
          <div className='row row-center groups-list-heading'>
            <SortHeader name='Name & Email' sort={sortBy} onSort={handleSort} width={'65%'} />
            <SortHeader name='Status' sort={sortBy} onSort={handleSort} width={'25%'} />
          </div>
          <div
            style={{
              height: 'calc(100vh - 375px)',
              overflow: 'auto'
            }}
          >
            {sortedItems && sortedItems.length == 0 && (
              <div
                className='column column-center'
                style={{
                  height: '80%',
                  justifyContent: 'center'
                }}
              >
                <svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M105 33.75H72.4999C71.6886 33.75 70.8991 33.4868 70.25 33L57.25 23.25C56.6009 22.7632 55.8114 22.5 55.0001 22.5H33.75C33.2575 22.5 32.7699 22.597 32.3149 22.7854C31.86 22.9739 31.4466 23.2501 31.0983 23.5983C30.7501 23.9466 30.4739 24.36 30.2854 24.8149C30.097 25.2699 30 25.7575 30 26.25V37.5H40.0001C40.8114 37.5 41.6009 37.7632 42.25 38.25L55.25 48C55.8991 48.4868 56.6886 48.75 57.4999 48.75H90C90.4925 48.75 90.9801 48.847 91.4351 49.0354C91.89 49.2239 92.3034 49.5001 92.6517 49.8483C92.9999 50.1966 93.2761 50.61 93.4646 51.0649C93.653 51.5199 93.75 52.0075 93.75 52.5V82.5H105.417C105.854 82.5 106.288 82.4138 106.692 82.2463C107.097 82.0788 107.464 81.8333 107.774 81.5237C108.083 81.2142 108.329 80.8467 108.496 80.4423C108.664 80.0379 108.75 79.6044 108.75 79.1667V37.5C108.75 37.0075 108.653 36.5199 108.465 36.0649C108.276 35.61 108 35.1966 107.652 34.8483C107.303 34.5001 106.89 34.2239 106.435 34.0354C105.98 33.847 105.492 33.75 105 33.75Z'
                    fill='#E7E7EE'
                  />
                  <path
                    d='M93.75 52.5V94.1667C93.75 95.0507 93.3988 95.8986 92.7737 96.5237C92.1486 97.1488 91.3007 97.5 90.4167 97.5H18.75C17.7554 97.5 16.8016 97.1049 16.0984 96.4017C15.3951 95.6984 15 94.7446 15 93.75V41.25C15 40.2554 15.3951 39.3016 16.0984 38.5984C16.8016 37.8951 17.7554 37.5 18.75 37.5H40C40.8114 37.5 41.6009 37.7632 42.25 38.25L55.25 48C55.8991 48.4868 56.6886 48.75 57.5 48.75H90C90.9946 48.75 91.9484 49.1451 92.6517 49.8484C93.3549 50.5516 93.75 51.5054 93.75 52.5Z'
                    stroke='#E7E7EE'
                    strokeWidth='5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M30 37.5V26.25C30 25.2554 30.3951 24.3016 31.0984 23.5984C31.8016 22.8951 32.7554 22.5 33.75 22.5H55C55.8114 22.5 56.6009 22.7632 57.25 23.25L70.25 33C70.8991 33.4868 71.6886 33.75 72.5 33.75H105C105.995 33.75 106.948 34.1451 107.652 34.8484C108.355 35.5516 108.75 36.5054 108.75 37.5V79.1667C108.75 79.6044 108.664 80.0379 108.496 80.4423C108.329 80.8467 108.083 81.2142 107.774 81.5237C107.464 81.8332 107.097 82.0787 106.692 82.2463C106.288 82.4138 105.854 82.5 105.417 82.5H93.75'
                    stroke='#E7E7EE'
                    strokeWidth='5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p
                  style={{
                    fontSize: 18,
                    opacity: 0.5,
                    fontWeight: 600
                  }}
                >
                  No results for users yet
                </p>
              </div>
            )}
            {/* {loading && <LoadingIndicator />} */}

            {sortedItems &&
              sortedItems.map(el => {
                const { userId, firstName, lastName, email, status } = el

                return (
                  <div key={userId} className='groups-list-item row row-center'>
                    <div onClick={() => setUserViewId(el.userId)} style={{ width: '65%' }} className='row row-center'>
                      <UserAvatar
                        id={userId}
                        style={{ background: '#fff' }}
                        firstName={firstName}
                        lastName={lastName}
                      />
                      <div className='column' style={{ maxWidth: '320px' }}>
                        <p
                          className='one-sthing'
                          style={{
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden'
                          }}
                        >
                          {(firstName || 'unknown') + ' ' + (lastName || 'unknown')}
                        </p>
                        <p
                          style={{
                            color: '#76767F',
                            fontSize: '14px',
                            marginBottom: '6px'
                          }}
                        >
                          {email}
                        </p>
                      </div>
                    </div>

                    <div
                      style={{
                        width: '25%',
                        display: 'flex'
                      }}
                    >
                      <CampaignUsersStatus status={status} />
                    </div>
                  </div>
                )
              })}
          </div>
        </>
      )}
      {activeTab == 2 && (
        <>
          <div className='row row-center groups-list-heading'>
            <SortHeader name='User Name' sort={sortBy} onSort={handleSortSims} width={'30%'} />
            <SortHeader name='Subject' sort={sortBy} onSort={handleSortSims} width={'30%'} />
            <SortHeader name='Status' sort={sortBy} onSort={handleSortSims} width={'20%'} />
            <SortHeader name='Date & Time' sort={sortBy} onSort={handleSortSims} width={'15%'} />
          </div>
          <div
            style={{
              height: 'calc(100vh - 375px)',
              overflow: 'auto'
            }}
          >
            {sortedSimItems && sortedSimItems.length == 0 && (
              <div
                className='column column-center'
                style={{
                  height: '80%',
                  justifyContent: 'center'
                }}
              >
                <svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M105 33.75H72.4999C71.6886 33.75 70.8991 33.4868 70.25 33L57.25 23.25C56.6009 22.7632 55.8114 22.5 55.0001 22.5H33.75C33.2575 22.5 32.7699 22.597 32.3149 22.7854C31.86 22.9739 31.4466 23.2501 31.0983 23.5983C30.7501 23.9466 30.4739 24.36 30.2854 24.8149C30.097 25.2699 30 25.7575 30 26.25V37.5H40.0001C40.8114 37.5 41.6009 37.7632 42.25 38.25L55.25 48C55.8991 48.4868 56.6886 48.75 57.4999 48.75H90C90.4925 48.75 90.9801 48.847 91.4351 49.0354C91.89 49.2239 92.3034 49.5001 92.6517 49.8483C92.9999 50.1966 93.2761 50.61 93.4646 51.0649C93.653 51.5199 93.75 52.0075 93.75 52.5V82.5H105.417C105.854 82.5 106.288 82.4138 106.692 82.2463C107.097 82.0788 107.464 81.8333 107.774 81.5237C108.083 81.2142 108.329 80.8467 108.496 80.4423C108.664 80.0379 108.75 79.6044 108.75 79.1667V37.5C108.75 37.0075 108.653 36.5199 108.465 36.0649C108.276 35.61 108 35.1966 107.652 34.8483C107.303 34.5001 106.89 34.2239 106.435 34.0354C105.98 33.847 105.492 33.75 105 33.75Z'
                    fill='#E7E7EE'
                  />
                  <path
                    d='M93.75 52.5V94.1667C93.75 95.0507 93.3988 95.8986 92.7737 96.5237C92.1486 97.1488 91.3007 97.5 90.4167 97.5H18.75C17.7554 97.5 16.8016 97.1049 16.0984 96.4017C15.3951 95.6984 15 94.7446 15 93.75V41.25C15 40.2554 15.3951 39.3016 16.0984 38.5984C16.8016 37.8951 17.7554 37.5 18.75 37.5H40C40.8114 37.5 41.6009 37.7632 42.25 38.25L55.25 48C55.8991 48.4868 56.6886 48.75 57.5 48.75H90C90.9946 48.75 91.9484 49.1451 92.6517 49.8484C93.3549 50.5516 93.75 51.5054 93.75 52.5Z'
                    stroke='#E7E7EE'
                    strokeWidth='5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M30 37.5V26.25C30 25.2554 30.3951 24.3016 31.0984 23.5984C31.8016 22.8951 32.7554 22.5 33.75 22.5H55C55.8114 22.5 56.6009 22.7632 57.25 23.25L70.25 33C70.8991 33.4868 71.6886 33.75 72.5 33.75H105C105.995 33.75 106.948 34.1451 107.652 34.8484C108.355 35.5516 108.75 36.5054 108.75 37.5V79.1667C108.75 79.6044 108.664 80.0379 108.496 80.4423C108.329 80.8467 108.083 81.2142 107.774 81.5237C107.464 81.8332 107.097 82.0787 106.692 82.2463C106.288 82.4138 105.854 82.5 105.417 82.5H93.75'
                    stroke='#E7E7EE'
                    strokeWidth='5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p
                  style={{
                    fontSize: 18,
                    opacity: 0.5,
                    fontWeight: 600
                  }}
                >
                  No results for simulations yet
                </p>
              </div>
            )}
            {/* {loading && <LoadingIndicator />} */}

            {sortedSimItems &&
              sortedSimItems.map(el => {
                const { actionAt, firstName, lastName, email, status, subject, userId } = el

                return (
                  <div key={userId + subject} className='groups-list-item row row-center'>
                    <div
                      onClick={() => setUserViewId(userId)}
                      style={{
                        width: '30%',
                        cursor: 'pointer'
                      }}
                      className='row row-center hov-opacity-80'
                    >
                      <div className='column' style={{ maxWidth: '320px' }}>
                        <p className='text-shrink-1'>{(firstName || 'unknown') + ' ' + (lastName || 'unknown')}</p>
                        <p
                          style={{
                            color: '#76767F',
                            fontSize: '14px',
                            marginBottom: '6px'
                          }}
                        >
                          {email}
                        </p>
                      </div>
                    </div>

                    <div style={{ width: '30%' }} className='row row-center'>
                      <p>{subject}</p>
                    </div>

                    <div
                      style={{
                        width: '20%',
                        display: 'flex'
                      }}
                    >
                      <CampaignUsersStatus status={status} />
                    </div>
                    <div
                      style={{
                        width: '15%',
                        color: '#76767F'
                      }}
                    >
                      {dayjs.utc(actionAt).local().format('MMM DD, HH:mm')}
                    </div>
                  </div>
                )
              })}
          </div>
        </>
      )}
    </>
  )
}

const CampaignView = ({ open, selectedId, onClose, onEdit, onArchive }) => {
  const [currentCampaign, setCurrentCampaign] = useState(null)
  const [currentCampaignStats, setCurrentCampaignStats] = useState(null)
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false)

  const [openTemplatePreview, setOpenTemplatePreview] = useState(false)
  const [selectedTemplateId, setSelectedTemplateId] = useState(null)
  const [selectedInternalTemplateId, setSelectedInternalTemplateId] = useState(null)

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (open) {
      setLoading(true)
      Promise.all([
        simulationCampaignsService.getSimulationCampaign(selectedId),
        simulationCampaignsService.getSimulationCampaignStats(selectedId)
      ])
        .then(values => {
          setLoading(false)
          const [campaignData, campaignStats] = values
          setCurrentCampaign({
            ...campaignData.data,
            templates: [...campaignData.data.customTemplates, ...campaignData.data.internalTemplates]
          })
          setCurrentCampaignStats(campaignStats.data)
        })
        .catch(err => {
          setLoading(false)
          console.error(err)
        })
    } else {
      setCurrentCampaign(null)
      setCurrentCampaignStats(null)
    }
  }, [open])

  const handleArchive = () => {
    // groupsService.archiveGroup
    onArchive(selectedId, currentCampaign?.status == 'ARCHIVED')
    setOpenArchiveDialog(false)
    onClose()
  }

  const startAndEndDate = () => {
    if (currentCampaign) {
      const hasSameYear = dayjs(currentCampaign.startDate).year() == dayjs(currentCampaign.endDate).year()
      const hasSameMonth = dayjs(currentCampaign.startDate).month() == dayjs(currentCampaign.endDate).month()

      if (hasSameYear && hasSameMonth) {
        return `${dayjs(currentCampaign.startDate).format('MMMM')} ${dayjs(currentCampaign.startDate).format('DD')}-${dayjs(currentCampaign.endDate).format('DD')}, ${dayjs(currentCampaign.startDate).format('YYYY')}`
      } else if (hasSameYear) {
        return `${dayjs(currentCampaign.startDate).format('MMM DD')} - ${dayjs(currentCampaign.endDate).format('MMM DD, YYYY')}`
      } else {
        return `${dayjs(currentCampaign.startDate).format('MMM DD, YYYY')} - ${dayjs(currentCampaign.endDate).format('MMM DD, YYYY')}`
      }
    } else {
      return null
    }
  }

  return (
    <Drawer anchor='right' open={open} onClose={() => onClose()}>
      <div style={{ width: '1200px' }} className='row campaign-view'>
        <div style={{ width: '400px', height: '100vh', padding: '32px' }} className='column'>
          <p
            className='text-shrink-2'
            style={{
              fontSize: '24px',
              fontFamily: 'Satoshi',
              marginBottom: '36px'
            }}
          >
            {loading ? <Skeleton width={200} /> : currentCampaign?.name}
          </p>
          <div
            style={{
              padding: '16px 24px',
              borderRadius: '10px',
              border: '1px solid #E7E7EE',
              marginBottom: '16px'
            }}
          >
            <div className='column'>
              <div className='row'>
                <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M3.125 6.875H16.875V3.75C16.875 3.58424 16.8092 3.42527 16.6919 3.30806C16.5747 3.19085 16.4158 3.125 16.25 3.125H3.75C3.58424 3.125 3.42527 3.19085 3.30806 3.30806C3.19085 3.42527 3.125 3.58424 3.125 3.75V6.875Z'
                    fill='#E7E7EE'
                  />
                  <path
                    d='M16.25 3.125H3.75C3.40482 3.125 3.125 3.40482 3.125 3.75V16.25C3.125 16.5952 3.40482 16.875 3.75 16.875H16.25C16.5952 16.875 16.875 16.5952 16.875 16.25V3.75C16.875 3.40482 16.5952 3.125 16.25 3.125Z'
                    fill='#C7EFF4'
                    stroke='#303051'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path d='M13.75 1.875V4.375' stroke='#303051' strokeLinecap='round' strokeLinejoin='round' />
                  <path d='M6.25 1.875V4.375' stroke='#303051' strokeLinecap='round' strokeLinejoin='round' />
                  <path d='M3.125 6.875H16.875' stroke='#303051' strokeLinecap='round' strokeLinejoin='round' />
                </svg>

                <p
                  style={{
                    fontWeight: 600,
                    color: '#76767F',
                    marginBottom: '12px',
                    marginLeft: '10px'
                  }}
                >
                  Start and end date
                </p>
              </div>
              <div className='row'>
                <div
                  style={{
                    width: '1px',
                    height: '40px',
                    background: '#E7E7EE',
                    margin: '0px 20px 10px 10px'
                  }}
                ></div>
                <p style={{ fontWeight: 600 }}>{loading ? <Skeleton width={200} /> : startAndEndDate()}</p>
              </div>
              <div className='row'>
                <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    opacity='0.2'
                    d='M7.5 18.75L8.75 12.5L3.75 10.625L12.5 1.25L11.25 7.5L16.25 9.375L7.5 18.75Z'
                    fill='#1B1B26'
                  />
                  <path
                    d='M7.5 18.75L8.75 12.5L3.75 10.625L12.5 1.25L11.25 7.5L16.25 9.375L7.5 18.75Z'
                    fill='#D0F2BF'
                    stroke='#303051'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                <p
                  style={{
                    fontWeight: 600,
                    color: '#76767F',
                    marginBottom: '12px',
                    marginLeft: '10px'
                  }}
                >
                  Send attacks
                </p>
              </div>
              <div className='row'>
                <div style={{ width: 31 }}></div>
                <p style={{ fontWeight: 600 }}>
                  {loading ? (
                    <Skeleton width={100} />
                  ) : (
                    timelineOptions.find(el => el.value == currentCampaign?.timeline)?.name +
                    ', ' +
                    dayjs(currentCampaign?.startDate).format('MMM DD, YYYY')
                  )}
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: 20 }} className='row row-center'>
            <p style={{ fontWeight: 600 }}>Templates </p>
            <div
              style={{
                background: '#F7F4FF',
                borderRadius: 24,
                width: 24,
                height: 24,
                marginLeft: 10
              }}
              className='column column-center'
            >
              <p style={{ fontSize: 13 }}></p>
              {loading ? 0 : currentCampaign?.customTemplates.length + currentCampaign?.internalTemplates.length}
            </div>
          </div>

          {loading ? (
            <LoadingIndicator />
          ) : (
            <>
              <div className='row templates-grid'>
                {currentCampaign?.customTemplates.map(el => (
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setSelectedTemplateId(el.id)
                      setOpenTemplatePreview(true)
                    }}
                    key={el.id}
                    className={`templates-grid-item column`}
                  >
                    <div className='templates-grid-item-img'>
                      <div className='template-thumbbail'>
                        <div
                          onClick={e => {
                            e.preventDefault()
                          }}
                        >
                          <Letter
                            html={el.body
                              .replaceAll(
                                ' src="cid:[qrCodeImage]"',
                                'width="150px" src="https://admin.cyberlift.io/images/qr-in-template.jpg"'
                              )
                              .replaceAll(
                                ' src="[qrCodeImage]"',
                                'width="150px" src="https://admin.cyberlift.io/images/qr-in-template.jpg"'
                              )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='row row-start'>
                      <div className='column' style={{ marginLeft: '8px' }}>
                        <p className='templates-grid-item-title text-shrink-2'>{el.name}</p>
                        <p className='templates-grid-item-domain'>{el.sender}</p>
                      </div>
                    </div>
                  </div>
                ))}
                {currentCampaign?.internalTemplates.map(el => (
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setSelectedInternalTemplateId(el.id)
                      setOpenTemplatePreview(true)
                    }}
                    key={el.id}
                    className={`templates-grid-item column`}
                  >
                    <div className='templates-grid-item-img'>
                      <div className='template-thumbbail'>
                        <div
                          onClick={e => {
                            e.preventDefault()
                          }}
                        >
                          <Letter html={el.body} />
                        </div>
                      </div>
                    </div>
                    <div className='row row-start'>
                      <div
                        className='column'
                        style={{
                          marginLeft: '8px'
                        }}
                      >
                        <p className='templates-grid-item-title text-shrink-2'>{el.subject}</p>
                        <p className='templates-grid-item-domain'>{el.sender}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <Spacer />
            </>
          )}

          {/* <Spacer /> */}
          <div style={{ marginTop: '55px' }} className='row'>
            <Button
              variant='outlined'
              disabled={currentCampaign?.status !== 'IN_PROGRESS'}
              sx={{
                borderColor: '#E7E7EE',
                borderRadius: '12px',
                color: '#6123FF',
                textTransform: 'none',
                flex: '1',
                mr: '12px'
              }}
              startIcon={<EditIcon disabled={currentCampaign?.status !== 'IN_PROGRESS'} />}
              onClick={() => onEdit(currentCampaign.id)}
            >
              Edit Campaign
            </Button>
            <Button
              onClick={() => setOpenArchiveDialog(true)}
              variant='outlined'
              sx={{
                borderColor: '#E7E7EE',
                borderRadius: '12px',
                color: '#6123FF',
                textTransform: 'none'
              }}
              startIcon={currentCampaign?.status == 'ARCHIVED' ? <UnArchiveIcon /> : <ArchiveIcon />}
            >
              {currentCampaign?.status == 'ARCHIVED' ? 'Unarchive' : 'Archive'}
            </Button>
          </div>
        </div>
        <div
          style={{
            width: '800px',
            background: '#F8F8FB',
            borderLeft: '1px solid #E7E7EE',
            padding: '32px'
          }}
          className='column'
        >
          {loading ? null : currentCampaign ? (
            <CampaignViewDetails
              simulationsStats={currentCampaignStats}
              users={currentCampaign?.users}
              simulations={currentCampaign?.simulations}
            />
          ) : null}
        </div>
      </div>
      <ArchiveDialog
        open={openArchiveDialog}
        unarchive={currentCampaign?.status == 'ARCHIVED'}
        str={currentCampaign?.name || 'Manual Phishing Simulation Campaign'}
        description={
          currentCampaign?.status == 'ARCHIVED'
            ? 'This campaign will be unarchived. Users will now start receiving phishing simulations through this campaign.'
            : 'This campaign will be stopped and archived. Users will not receive any phishing simulations through this campaign. This action can be reversed.'
        }
        onAction={handleArchive}
        onClose={() => setOpenArchiveDialog(false)}
      />

      <Drawer
        anchor='right'
        open={openTemplatePreview}
        onClose={() => {
          setOpenTemplatePreview(false)
          setSelectedTemplateId(null)
        }}
      >
        <div
          style={{
            position: 'fixed',
            top: '24px',
            right: '1182px',
            cursor: 'pointer'
          }}
          onClick={() => {
            setOpenTemplatePreview(false)
            setSelectedTemplateId(null)
          }}
        >
          <CloseDrawer />
        </div>
        {selectedTemplateId && <CustomTemplatePreview id={selectedTemplateId} />}
        {selectedInternalTemplateId && <TemplateView id={selectedInternalTemplateId} />}
      </Drawer>
    </Drawer>
  )
}

export default CampaignView
